export const upsellings = {
    text1: "Services",
    text2: "Verwalten Sie Ihre Services",
    text3: "Liste der Services",
    text4: "Anbieter",
    text5: "Liste der Services, die Ihre Gäste sehen",
    text6: "Service anlegen",
    text7: "Name",
    text8: "Erstellt",
    text9: "Status",
    text10: "aktiv",
    text11: "inaktiv",
    text12: "Service bearbeiten",
    text13: "Service löschen",
    text14: "Es wurden keine Services gefunden.",
    text15: "Erfolgreich geändert.",
    text16: "Möchten Sie den Service wirklich löschen",
    text17: "Ihre gespeicherten Daten gehen verloren",
    text18: "Service löschen",
    text19: "Abbrechen",
    text20: "Erfolgreich gelöscht.",
    text21: "Service erstellen",
    text22: "Service-Informationen",
    text23: "Geben Sie die wichtigsten Angaben zum Service ein, die auf der Karte erscheinen.",
    text24: "Alle Unterkünfte",
    text25: "Unterkunft auswählen *",
    text26: "Namen eingeben",
    text27: "Name Ihres Services *",
    text28: "Automatisch",
    text29: "Manuell",
    text30: "Art der Bestätigung",
    text31: "Titel des Services",
    text32: "Titel eingeben *",
    text33: "Check-in/Check-out",
    text34: "Transfer",
    text35: "F&B",
    text36: "Saisonal",
    text37: "Familie",
    text38: "Romantik",
    text39: "SPA & Wellness",
    text40: "Kunst & Kultur",
    text41: "Aktivitäten",
    text42: "Services",
    text43: "Sonstiges",
    text44: "Kategorie *",
    text45: "Interner Service",
    text46: "Anbieter *",
    text47: "Beschreibung",
    text48: "Geben Sie die Beschreibung Ihres Services ein *",
    text49: "Preis",
    text50: "Wählen Sie die Preisart und legen Sie fest, wie viel Ihre Gäste für das Angebot zahlen.",
    text51: "Zahl eingeben",
    text52: "Pro Einheit",
    text53: "Pro Person",
    text54: "Pro Gruppe",
    text55: "Pro Tag",
    text555: "Pro Stunde",
    text56: "Preis pro",
    text57: "Bild",
    text58: "Laden Sie ein Bild hoch, das im Kopfbereich der Karte erscheint.",
    text59: "Service speichern",
    text60: "Wird geladen ...",
    text61: "Service erfolgreich erstellt.",
    text62: "Liste der Anbieter",
    text63: "Anbieter hinzufügen",
    text64: "ID",
    text65: "Name",
    text66: "E-Mail",
    text67: "Telefon",
    text68: "Anbieter bearbeiten",
    text69: "Anbieter entfernen",
    text70: "Anbieter anlegen",
    text71: "Fügen Sie ",
    text72: "Anbieter ",
    text73: "zu Ihrer Liste hinzu, um damit neue Angebote zu erstellen.",
    text74: "Namen eingeben",
    text75: "Name des Anbieters *",
    text76: "Land",
    text77: "Fehler",
    text78: "Geben Sie Ihre Nummer ein",
    text79: "Telefon *",
    text80: "E-Mail-Adresse *",
    text81: "Adresse",
    text82: "Anbieter hinzufügen",
    text83: "Erfolgreich erstellt.",
    text84: "Möchten Sie den Anbieter wirklich löschen?",
    text85: "Ihre gespeicherten Daten gehen verloren",
    text86: "Anbieter entfernen",
    text87: "Erfolgreich gelöscht.",
    text96: 'Verwalten Sie Ihre Abonnements und Rechnungen',
    
    // Correcciones 
    p1: "Preis auf Anfrage",
};